/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// Core
import { Component, Input, OnInit } from '@angular/core';
import { Wove } from 'aspect.js/';
import { SafeHtml } from '@angular/platform-browser';

// Constants
import { PLAN_PROMOTION_HEADER } from '@experience/shop/shared-browse/constants/shared-browse.constants';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';

// Interfaces

@Wove({ moduleName: PLAN_PROMOTION_HEADER.PLAN_PROMOTION_HEADER_MODULE })
/**
 * Component for the UI footer.
 * @access protected - used by the Root module
 */
@Component({
  selector: 'tmo-plan-promotion-header',
  //encapsulation: ViewEncapsulation.None, // allows for style sheet to insert global styles
  templateUrl: './plan-promotion-header.component.html',
})
export class PlanPromotionHeaderComponent implements OnInit {
  @Input() promotionTagIconTemplate: SafeHtml;
  @Input() planPromotions: { [key: string]: string };
  @Input() planId: string;
  public promotionTextMaxLength: number;
  @Input() public isCPS: boolean;
  private isAuthFlow: boolean;
  private isAddAFan: boolean;

  constructor(
    private stateStoreUtilService: StateStoreUtilsService,
    private objectService: ObjectService
  ) {
    this.planPromotions = {};
  }

  public ngOnInit(): void {
    this.promotionTextMaxLength = PLAN_PROMOTION_HEADER.PROMOTION_TEXT_MAX_LENGTH;
    this.isAuthFlow = !!this.stateStoreUtilService.getAuthCustomerId();
    this.isAddAFan = this.stateStoreUtilService.getAddFan();
  }

  public getPromotion(): string {
    let promotionText: string = '';
    if (this.planPromotions) {
      if (this.isAuthFlow && !this.isAddAFan) {
        if (this.isCPS) {
          promotionText = this.objectService.get(
            this.planPromotions,
            `changeRatePlanPromotions.${this.planId}`,
            ''
          );
        } else {
          promotionText = this.objectService.get(
            this.planPromotions,
            `addALinePromotions.${this.planId}`,
            ''
          );
        }
      } else {
        promotionText = this.objectService.get(
          this.planPromotions,
          `unAthFlowPromotions.${this.planId}`,
          ''
        );
      }
    }
    return promotionText;
  }
}
